import { ButtonBase } from '@presov.sk/presov-ui-react';
import React from 'react';

type Props = {
  children: React.ReactNode;
  selected: boolean;
  onClick: () => void;
  fullWidth?: boolean;
};

/**
 * Voľba v rozhodovaní o náleze - smer duplicity, nová kategória.
 *
 * Je to **vlastný komponent, nie `Chip` z knižnice**, a to z dvoch dôvodov,
 * ktoré oba platia len tu:
 *
 *  - **Vybraná voľba je `primary`, nie čierna.** Knižnica má čiernu plochu ako
 *    jediné miesto v systéme s plnou tmavou výplňou a to sa nikam nerozširuje;
 *    v karte nálezu je ale plných tmavých plôch viac (hlavička karty, prepínače)
 *    a čierny chip medzi nimi nebolo poznať ako vybraný.
 *  - **Klikateľná je celá plocha.** `Chip` z knižnice má odsadenie na obale
 *    a nie na tlačidle, takže sa doň musí trafiť do písmen. Opravené to je
 *    v `ui-react` 2.5.1, ktorá zatiaľ nie je vydaná - a keď bude, tento
 *    komponent zostáva pre tú prvú vec.
 *
 * `ButtonBase` nesie **aj odsadenie aj výšku**: keby ich mal obal, klik by na
 * okrajoch znovu nefungoval, teda presne tá chyba, kvôli ktorej to vzniklo.
 */
const DecisionChip: React.FC<Props> = ({
  children,
  selected,
  onClick,
  fullWidth = false,
}) => (
  <ButtonBase
    onClick={onClick}
    aria-pressed={selected}
    sx={(theme) => ({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 36,
      px: 1.75,
      py: 0.5,
      width: fullWidth ? '100%' : undefined,
      borderRadius: `${theme.shape.borderRadiusSm}px`,
      border: '1px solid',
      borderColor: selected ? 'primary.main' : 'divider',
      backgroundColor: selected ? 'primary.main' : 'background.default',
      color: selected ? 'common.white' : 'grey.600',
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 500,
      lineHeight: 1.3,
      textAlign: 'center',
      transition: 'background-color 120ms ease-in, border-color 120ms ease-in',
      ...(!selected && {
        '&:hover': {
          backgroundColor: 'grey.50',
          borderColor: 'grey.400',
        },
      }),
    })}
  >
    {children}
  </ButtonBase>
);

export default DecisionChip;
